export default __webpack_public_path__ + "static/media/mlc-residence-group-logo.bf44e7a8.jpg";